const Endpoints = {
    v2: {
        participantSessionsOverview: '/api/v2/participant-sessions/overview.json'
    },
    authorise: '/api/v1/user/authorize/participant',
    authoriseGuest: '/api/v1/user/authorize/guest',
    entraRedirect: '/api/v1.1/authorize/microsoft',
    entraLogin: '/api/v1.1/login/microsoft',
    entraRegister: '/api/v1.1/register/{accountHasRoleSlug}/microsoft',

    logout: '/api/v1/user/logout',
    sectionInfoWithSlug: '/api/v1/{section}/{slug}',
    sectionUpdate: '/api/v1/{section}/{slug}/update',
    participations: {
        participations: '/api/v1/get-inbox-messages/{accountSlug}',
        participantSessionInfo: '/api/v1/participantSession/{slug}/info',
        participantSession: '/api/v2/participant-sessions/{participantSessionId}',
        updateParticipantSession: '/api/v2/participant-sessions/{participantSessionId}/self'
    },
    educationLevels: '/api/v2/education-levels',
    questionnaires: {
        questionnaireSettingSSO: '/api/v1.1/questionnaire-setting/{id}/sso',
        settingsForQuestionnaires: '/api/v2/settings-for-questionnaires',
        questionnaireSessions: '/api/v2/questionnaire-sessions',
        updateAnswers: '/api/v1.1/questionnaire-sessions/{id}/update-answers',
        completeQuestionnaireSession: '/api/v2/questionnaire-sessions/{id}/finish',
        practiceQuestionnaireSessions: '/api/v2/questionnaire-sessions/practice',
        verifyAnswersForPractice: '/api/v1.1/practice/verify-answers',
        testing: {
            autofillQuestionnaire: '/api/v1.1/questionnaire-sessions/{id}/autofill-questionnaire'
        }
    },
    assessmentReport: {
        getReport: '/api/v1/get-assessment-report-data/{participantSessionSlug}',
        sharingPermission: '/api/v2/report-permissions',
        getReportDetailPage: '/api/v1/get-assessment-report-section-data/{participantSessionSlug}/{reportSectionHandle}',
        saveReflectionText: '/api/v1/submit-reflection-on-report/{participantSessionSlug}',
        downloadPdfReport: '/api/v1/download-pdf-report-v2',
        saveReflectionExerciseText: '/api/v1/submit-reflection-exercise-on-report/{participantSessionSlug}/{fieldHandle}',
        getGeneratedPdfReport: '/api/v2/generated-pdf-reports/{id}',
        generatePdfReport: '/api/v1.1/generated-pdf-report/{participantSessionId}',
        deletePdfReport: '/api/v1.1/generated-pdf-report/{participantSessionId}/delete',
        setPhase: '/api/v2/participant-sessions/{id}/phase'
    },
    forgotPassword: {
        requestEmail: '/api/v1/user/request-password',
        validateToken: '/api/v1/user/verify-password-reset/{email}/{token}',
        changePassword: '/api/v1/user/change-password'
    },
    register: {
        accountStatus: '/api/v1/user/status/{slug}',
        createAccount: '/api/v1/user/invite/create-account/{slug}',
        accountLogin: '/api/v1/user/invite/login/{slug}',
        participantAcceptTerms: '/api/v1/participant/invite/terms-and-conditions/{slug}'
    },
    reports: {
        getReports: '/api/v1.1/reports-overview',
        reportViewedStatus: '/api/v1/report-viewed-by-participant/{slug}'
    },
    profile: {
        updateParticipantDetails: '/api/v1/account/{slug}/get-info-when-amend-participant',
        uploadCv: '/api/v1/update-or-create-file-for-account/{slug}',
        downloadCv: '/api/v1/download-cv/{slug}',
        deleteCv: '/api/v1/delete-file-for-account/{slug}'
    },
    selfRegistration: {
        createAccount: '/api/v2/participant-sessions/self-registration',
        sendLoginLink: '/api/v2/login-links',
        publicProjectSettings: '/api/v2/project-settings/{projectSettingId}/view-public', // legacy endpoint which is kept until all clients migrated
        assessmentTemplates: '/api/v2/assessment-templates'
    },
    magicLink: {
        participantSessions: '/api/v2/participant-sessions',
        useLink: '/api/v2/login-links/{linkHash}',
        sendLoginLink: '/api/v2/login-links'
    },
    groupReports: {
        getGroupReportWithData: '/api/v1.1/group-reports/{id}'
    }
};

export default Endpoints;
